import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";

import DefaultFunctionsUtils from "../../utils/classes/DefaultFunctionsUtils";

import { useGlobalRegisters } from "../../context/GlobalRegisters/GlobalRegistersContext";

const useStyles = makeStyles((theme) => ({
  maxWidth: {
    width: "100%",
  },
	floatingButton: {
    transition: 'transform 0.3s',
  
    '&:hover': {
      transform: 'translateY(-5px)',
    },
  }
}));

const EditTicketModal = ({ modalOpen, onClose, ticket, ticketStatus }) => {
	//	***************
	//	** Variables **
	//	***************
	const classes = useStyles();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	
	const [selectedQueue, setSelectedQueue] = useState('');

	const [selectedSubqueue, setSelectedSubqueue] = useState('');

	const { allQueues, allSubqueues, userQueues, setShouldSyncRouteOnMenu } = useGlobalRegisters();
	const queues = ticketStatus === "pending" ? allQueues : userQueues;



	//	***************
	//	** Functions **
	//	***************
	const handleQueueChange = (e) => {
		setSelectedQueue(e.target.value);
		setSelectedSubqueue("");
	};

	const handleClose = () => { 
		onClose(); 
		setSelectedQueue("");
		setSelectedSubqueue("");
	};

	const handleEditTicket = async (event) => {
		event.preventDefault();
		
		if (selectedQueue === "") {
			toast.info(i18n.t("backendErrors.QUEUE_NOT_SELECTED"));
		}
		else if (allSubqueues === 0) {
			toast.info(i18n.t("editTicketModal.toast.subqueuesNotLoaded"));
		}
		else if (allSubqueues.some(subqueue => subqueue.queueId === selectedQueue) && selectedSubqueue === "") {
			toast.info(i18n.t("backendErrors.SUBQUEUE_NOT_SELECTED"));
		}
		else {
			setLoading(true);

			try {
				let data = {};
				data.queueId = selectedQueue;
				data.subqueueId = selectedSubqueue !== "" ? selectedSubqueue : null;
				data.contactId = ticket.contactId;
	
				await api.put(`/tickets/${ticket.id}/1`, data);
	
				setLoading(false);
				DefaultFunctionsUtils.redirectToTicketsPage(history);
				setShouldSyncRouteOnMenu(true);
				selectedQueue("");
				selectedSubqueue("");
			}
			catch (exception) {
				setLoading(false);
				toast.error(exception);
			}
			finally {
				handleClose();
			}
		}
	};



	//	************
	//	** Return **
	//	************
	return (
		<Dialog open={modalOpen} onClose={handleClose} maxWidth="lg" scroll="paper">
			<form style={{padding: "0px 15px 15px 15px"}} onSubmit={async (event) => await handleEditTicket(event)}>
				<DialogTitle id="form-dialog-title">
					{i18n.t("editTicketModal.title")}
				</DialogTitle>

				<DialogContent dividers>
					<FormControl variant="outlined" className={classes.maxWidth}>
						<InputLabel>{i18n.t("editTicketModal.fieldQueueLabel")}</InputLabel>
						<Select
							value={selectedQueue}
							onChange={(e) => handleQueueChange(e)}
							label={i18n.t("editTicketModal.fieldQueueLabel")}
						>
							<MenuItem value={''}>&nbsp;</MenuItem>
							{queues.map((queue) => (<MenuItem key={queue.id} value={queue.id}>{queue.name}</MenuItem>))}
						</Select>
					</FormControl>

					{selectedQueue !== "" && allSubqueues !== 0 && allSubqueues.some(subqueue => subqueue.queueId === selectedQueue) && (
						<>
							<br /><br />
							<FormControl variant="outlined" className={classes.maxWidth}>
								<InputLabel>{i18n.t("editTicketModal.fieldSubqueueLabel")}</InputLabel>
						
								<Select 
									value={selectedSubqueue}
									onChange={(e) => setSelectedSubqueue(e.target.value)}
									label={i18n.t("editTicketModal.fieldSubqueueLabel")}
								>
									<MenuItem value={''}>&nbsp;</MenuItem>

									{allSubqueues.map((subqueue) => (
										subqueue.queueId === selectedQueue && (
											<MenuItem key={subqueue.id} value={subqueue.id}>{subqueue.name}</MenuItem>
										)
									))}
								</Select>
							</FormControl>
						</>
					)} 
				</DialogContent>

				<br />

				<DialogActions>
					<Button
						onClick={handleClose}
						color="inherit"
						disabled={loading}
						variant="outlined"
						className={classes.floatingButton}
					>
						{i18n.t("editTicketModal.buttons.cancel")}
					</Button>
					<ButtonWithSpinner
						variant="contained"
						type="submit"
						color="primary"
						loading={loading}
						className={classes.floatingButton}
					>
						{i18n.t("editTicketModal.buttons.ok")}
					</ButtonWithSpinner>
				</DialogActions>
			</form>
		</Dialog>
	);
};

export default EditTicketModal;